import React, { useEffect, useState } from 'react'
import { saveUserItineraryOptions } from '../../store/userAccount/userAccount.actions'
import { useTemporaryVisible } from '../genericComponents/useTemporaryVisible'
import T from '../i18n/T'
import sUserManageFavorites from '../UserAccount/connected/userFavorites/UserManageFavorite.less'
import { useAction } from '../utils/react-redux'
import FavouriteModeBox from './FavouriteModeBox'
import s from './ItineraryOptions.less'
import ModeSpeedSettingsBox from './ModeSpeedSettingsBox'
import VehicleSettingsBox from './VehicleSettingsBox'

const ItineraryOptions = () => {
  const execSaveUserItineraryOptions = useAction(saveUserItineraryOptions)
  const [visible, setVisible] = useTemporaryVisible()
  const [itineraryOptionsError, setItineraryOptionsError] = useState()

  useEffect(() => {
    return async () => {
      const saveItineraryOptionsResult = await execSaveUserItineraryOptions()

      if (saveItineraryOptionsResult?.error) {
        setVisible(true)
        setItineraryOptionsError(saveItineraryOptionsResult.error)
      }
    }
  }, [])

  return (
    <>
      {visible && <div className={sUserManageFavorites.errorMessage}>{itineraryOptionsError}</div>}
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.preferred-mode'} />
        </h2>
        <div className={s.boxContent}>
          <FavouriteModeBox />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.car'} />
        </h2>
        <div className={s.boxContent}>
          <VehicleSettingsBox modeId="car" />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.motorbike'} />
        </h2>
        <div className={s.boxContent}>
          <VehicleSettingsBox modeId="motorbike" hasOwnSwitcher />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.walk'} />
        </h2>
        <div className={s.boxContent}>
          <ModeSpeedSettingsBox modeId="walk" />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.bike'} />
        </h2>
        <div className={s.boxContent}>
          <ModeSpeedSettingsBox modeId="bike" hasOwnSwitcher />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.trottinette'} />
        </h2>
        <div className={s.boxContent}>
          <ModeSpeedSettingsBox modeId="trottinette" hasOwnSwitcher />
        </div>
      </div>
    </>
  )
}

export default ItineraryOptions
